const productPriceSplit = (value: number, roundCents = false) => {
  const priceSplit = (value / 100).toFixed(2).split(".");

  const dollars: string = priceSplit[0];

  if (roundCents && priceSplit[1] === "00") {
    return { dollars };
  }

  const cents: string = priceSplit[1];

  return { dollars, cents };
};

export default productPriceSplit;
